import { APP_INITIALIZER, ErrorHandler, isDevMode, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { SharedModule } from './common/shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { OrdersModule } from './orders/orders.module';
import { StoreModule } from '@ngrx/store';
import { calculationReducer } from './calculation/calculation.reducer';
import { JwtInterceptor } from './auth/jwt.interceptor';
import { AuthModule } from './auth/auth.module';
import { ComponentsModule } from './components/components.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NavigationComponent } from './navigation/navigation.component';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { FeaturedProductsModule } from './featured-products/featured-products.module';
import { FooterComponent } from './footer/footer.component';
import { CustomOrdersComponent } from './custom-orders/custom-orders.component';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { environment } from '../environments/environment';
import { BreadcrumbModule } from 'xng-breadcrumb';
import * as Sentry from '@sentry/angular-ivy';
import { UnknownErrorComponent } from './unknown-error/unknown-error.component';
import { NotFoundComponent } from './404/not-found.component';
import { MatTableModule } from '@angular/material/table';
import { ApiModule } from '../api/api.module';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { MatNativeDateModule } from '@angular/material/core';
import { DragScrollModule } from 'ngx-drag-scroll';
import { MatRadioModule } from '@angular/material/radio';
import { NgOptimizedImage } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { MatCardModule } from '@angular/material/card';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CoreComponent } from './core.component';

// export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
//   return localStorageSync({keys: ['calculations'], rehydrate: true})(reducer);
// }
// const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    FooterComponent,
    CustomOrdersComponent,
    UnknownErrorComponent,
    NotFoundComponent,
    CoreComponent,
  ],
  imports: [
    ApiModule.forRoot({ rootUrl: environment.api.replace('/api', '') }),
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ComponentsModule,
    HttpClientModule,
    SharedModule,
    MatButtonModule,
    OrdersModule,
    FeaturedProductsModule,
    StoreDevtoolsModule,
    StoreModule.forRoot({ calculations: calculationReducer }),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
    AuthModule,
    MatMenuModule,
    MatCheckboxModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatExpansionModule,
    BreadcrumbModule,
    MatTableModule,
    ...(!!environment.ga ? [NgxGoogleAnalyticsModule.forRoot(environment.ga), NgxGoogleAnalyticsRouterModule] : []),
    // ...(!!environment.pixel ? [PixelModule.forRoot({ enabled: true, pixelId: environment.pixel })] : []),
    GoogleTagManagerModule.forRoot({ id: environment.gtm }),
    MatNativeDateModule,
    DragScrollModule,
    MatRadioModule,
    NgOptimizedImage,
    MatCardModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule,
    NgxGoogleAnalyticsModule,
  ],
  providers: [
    CookieService,
    { provide: 'googleTagManagerMode', useValue: 'silent' },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    ...(environment.production
      ? [
          {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({}),
          },
          {
            provide: Sentry.TraceService,
            deps: [Router],
          },
          {
            provide: APP_INITIALIZER,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            useFactory: () => () => {},
            deps: [Sentry.TraceService],
            multi: true,
          },
        ]
      : []),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
